import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { select, fork, take, put, all } from 'redux-saga/effects';
import i18n from 'i18next';
import ddt from '@wix/da-ddt';
import { reloadStashStream, reloadStashStreamDone } from '../actions';
import { getCurrentFolderId } from '../selectors';
import { uploadFileHandler } from './uploadFile';
import { getAllUploads } from '../../redux/uploads/selectors';
import { putErrorNotification } from '../../utils/saga';
const MAX_CONCURRENT_UPLOADS_ALLOWED = 10;
function* uploadFilesSaga(action) {
    // reducer fires before the saga middleware, so the files from the action
    // payload are already in the store
    const allUploads = yield select(getAllUploads);
    const activeUploads = allUploads.filter((item)=>item.hasOwnProperty('progress'));
    const newFileUploads = action.payload;
    const remainingUploadSlots = Math.max(0, MAX_CONCURRENT_UPLOADS_ALLOWED - activeUploads.length);
    if (remainingUploadSlots < newFileUploads.length) {
        ddt.error('MediaManager', 'Maximum concurrent file uploads exceeded. Truncating...', newFileUploads.slice(remainingUploadSlots));
        yield putErrorNotification(i18n.t('mediapopup.upload.error.maxConcurrentUploadsExceeded', {
            count: MAX_CONCURRENT_UPLOADS_ALLOWED
        }));
    }
    yield put(reloadStashStream());
    yield take(reloadStashStreamDone); // wait for reload to complete
    const currentFolderId = yield select(getCurrentFolderId);
    yield all(newFileUploads.slice(0, remainingUploadSlots).map((payload)=>{
        const folderId = payload.folderId || currentFolderId;
        return fork(uploadFileHandler, _object_spread_props(_object_spread({}, payload), {
            folderId
        }));
    }));
}
export default uploadFilesSaga;

//# sourceMappingURL=uploadFiles.js.map